module.exports = __webpack_public_path__ + "img/Debbie Wood.b877f5cc.jpg";